import type { RejectReason } from '../api/contracts'

/**
 * Reason to Persian copy is a frontend concern — the backend returns the enum and never
 * a display string. Strings are taken verbatim from the artboard where it shows them.
 */
const TEXT: Record<RejectReason, string> = {
  duplicate_in_pallet: 'این سریال قبلاً در همین پالت ثبت شده است',
  belongs_to_other_pallet: 'این سریال در پالت دیگری ثبت شده است',
  unknown_serial: 'این سریال در سامانه شناسایی نشد',
  pallet_full: 'ظرفیت پالت پر شده است',
  pallet_closed: 'این پالت بسته شده و پذیرش ندارد',
  erp_error: 'خطای سامانه اصلی در ثبت این سریال',
}

/** Short form for the chip on a failed row in the queue list. */
const SHORT: Record<RejectReason, string> = {
  duplicate_in_pallet: 'تکراری',
  belongs_to_other_pallet: 'پالت دیگر',
  unknown_serial: 'ناشناخته',
  pallet_full: 'ظرفیت پر',
  pallet_closed: 'پالت بسته',
  erp_error: 'خطای سامانه',
}

export function rejectReasonText(reason: RejectReason | null | undefined): string {
  return reason ? TEXT[reason] : 'دلیل نامشخص'
}

export function rejectReasonShort(reason: RejectReason | null | undefined): string {
  return reason ? SHORT[reason] : 'نامشخص'
}

/**
 * A reject the operator can act on by retrying the same request with
 * overrideExisting: true — the «انتقال سریع» path. Everything else needs a
 * different decision, so it must not offer a retry that will fail identically.
 */
export function isTransferable(reason: RejectReason | null | undefined): boolean {
  return reason === 'belongs_to_other_pallet'
}

/**
 * A reject that a plain retry could still clear: the ERP was transiently unhappy.
 * duplicate/unknown/full/closed are settled answers — retrying them is pointless.
 */
export function isRetryable(reason: RejectReason | null | undefined): boolean {
  return reason === 'erp_error'
}
